<template>
  <div>
    <div class="form-inline">
      <select v-model="selected" class="form-control">
        <option :value="null" disabled>---</option>
        <option
          v-for="(option, index) in availableOptions"
          :key="index"
          :value="option"
          >{{ option.name }}</option
        >
      </select>
      <v-button @click="addOption()" :disabled="!selected">+</v-button>
    </div>
    <div v-for="(choice, index) in value" :key="index" class="form-inline">
      <label :for="'slider' + index">{{ choice.name }}</label>
      <input
        class="form-control"
        type="range"
        :id="'slider' + index"
        :min="min"
        :max="max"
        v-model.number="choice.chance"
        @input="changeSlider(index)"
        step="0.01"
      />
      <input
        class="form-control"
        type="number"
        :min="min"
        :max="max"
        :value="Math.round(choice.chance)"
        @change="changeBox(index, $event)"
      />
      <v-button @click="removeOption(index)">-</v-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
      description: "an array of objects {id: int, name: String, chance: int}"
    },
    items: {
      type: Array
    }
  },
  data() {
    return {
      min: 0,
      max: 100,
      selected: null
    };
  },
  computed: {
    availableOptions() {
      return this.items.filter(
        item => !this.value.map(v => v.id).includes(item.id)
      );
    }
  },
  methods: {
    changeSlider(index) {
      if (this.value.length == 1) {
        this.value[0].chance = 100;
        this.$emit("input", this.value);
        return;
      }

      const sum = this.value
        .map(option => option.chance)
        .reduce((sum, val) => sum + val, 0);
      const diff = sum - 100;
      let remainder = 0;

      for (let i in this.value) {
        if (i != index) {
          //don't modify the index which is being dragged
          let val = this.value[i].chance - diff / (this.value.length - 1);
          if (val < 0) {
            remainder += val;
            val = 0;
          }
          this.$set(this.value, i, { ...this.value[i], chance: val });
        }
      }

      if (remainder) {
        const filteredLength = this.value.filter(
          (val, key) => val.chance > 0 && key != index
        ).length;
        for (let i in this.value) {
          if (i != index && this.value[i].chance > 0) {
            this.$set(this.value, i, {
              ...this.value[i],
              chance: this.value[i].chance + remainder / filteredLength
            });
          }
        }
      }

      this.$emit("input", this.value);
    },
    changeBox(index, e) {
      if (e.target.value.length > 3) {
        e.target.value = "";
      }
      if (isNaN(e.target.value) || e.target.value > 100 || e.target.value < 0) {
        e.target.value = "";
      } else {
        this.value[index].chance = Math.round(e.target.value);
        this.changeSlider(index);
      }
    },
    addOption() {
      if (this.selected) {
        this.value.push({ chance: 0, ...this.selected });
        this.selected = null;
        this.changeSlider();
      }
    },
    removeOption(index) {
      this.value.splice(index, 1);
      this.changeSlider();
    }
  }
};
</script>

<style>
.card .form-inline label {
  color: black;
  font-size: 1rem;
}
.form-inline {
  gap: 8px;
}
</style>
